/**
 * Fetch (method POST)
 * @param {object|array} obj 
 * @param {string} nonce la valeur du nonce présent dans le input hidden généré par wp_nonce_field()
 * => à transmettre dans les headers (X-WP-Nonce). L'api REST de wordpress vérifira dans le cookie d'auth REST si le nonce est bon 
 * @returns {Promise}
 */
export const sendMail = async (obj, nonce) => {
    const response = await fetch(VDB_CONFIG.url.root+"/wp-json/vdbposts/v1/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce},
        body: JSON.stringify(obj)
    });
    const {ok, status, statusText} = response;
    const datas = await response.json();
    return {datas, status, statusText};
}